export enum TipoTempo {
  Central = 0,
  ACaminho = 1,
  Aguardo = 2,
  Descarga = 3,
  Lavagem = 4,
  Retorno = 5,
  Total = 6,
}
